<template>
  <div class="default-layout">
    <Info />
    <Header />
    <Sidebar />
    <CreditLimit v-if="showCreditLimit()" />
    <SelectedVehicleBar />
    <Attention />
    <template v-if="config.global.topicsSlider">
      <TopicSlider />
    </template>
    <div class="main">
      <Notifications />
      <Breadcrumbs v-if="showBreadcrumbs" />
      <slot />
    </div>
    <!-- <Newsletter /> -->
    <FooterPages />
    <Footer />
    <BottomNavigation />
    <MainPageLoader />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { SelectedVehicleBar, CreditLimit } from '@/modules/level4';
import { FooterPages, Info } from '@/modules/page';
import Header from '../components/layouts/Header.vue';
import BottomNavigation from '../components/layouts/BottomNavigation.vue';
import Sidebar from '../components/layouts/Sidebar.vue';
import TopicSlider from '../components/layouts/TopicSlider.vue';
import Footer from '../components/layouts/Footer.vue';
import Notifications from '../components/layouts/Notifications.vue';
import Attention from '../components/layouts/Attention.vue';
import Breadcrumbs from '../components/layouts/Breadcrumbs.vue';
import MainPageLoader from '../components/layouts/MainPageLoader.vue';

export default {
  name: 'DefaultLayout',
  components: {
    Header,
    BottomNavigation,
    Sidebar,
    Footer,
    Attention,
    TopicSlider,
    Notifications,
    Breadcrumbs,
    CreditLimit,
    SelectedVehicleBar,
    MainPageLoader,
    FooterPages,
    Info,
  },
  computed: {
    showBreadcrumbs() {
      return this.$route.meta.breadcrumbs;
    },
    ...mapGetters({
      storeConfig: 'core/storeConfig',
      config: 'core/config',
    }),
  },
  methods: {
    showCreditLimit() {
      return !!this.storeConfig?.general?.showCreditLimit;
    },
  },
};
</script>

<style lang="scss" scoped></style>
